import axios from 'axios'

axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded'
const service = axios.create({
  baseURL: '/index.php',
  timeout: 5000
  //  headers: {'X-Custom-Header': 'foobar'}
})

//  let LoadingEl
//  请求拦截器
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    alert('请求出错！')
    Promise.reject(error)
  }
)

//  回复拦截器
service.interceptors.response.use(
  response => {
    if (response.data.code !== 0) {
      alert('操作失败，原因：' + response.data.msg)
    }
    return response.data.data
  },
  error => {
    alert('请求出错！')
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/service.js